import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ud3dmwvnmf: FaireBrandEntity = {
  token: "b_ud3dmwvnmf",
  type: "brand",
  name: "You Are Uniquely Magic",
  avatarUrl:
    "https://cdn.faire.com/fastly/92a41a753de2c4e3281c9c0b2506fbd37d9b3480659975251c501054b89050e2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/61ee528523ccb5ff771a15ee2368e53eaddf977058314ad72cb91d750a092554.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/92a41a753de2c4e3281c9c0b2506fbd37d9b3480659975251c501054b89050e2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/61ee528523ccb5ff771a15ee2368e53eaddf977058314ad72cb91d750a092554.jpeg",
  location: "Ogden, UT, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 240,
  isTopShop: true,
  isInsider: true,
  description:
    "Follow us on TikTok and Instagram @youareuniquelymagic to see our new creations, get to know us and share the Magic!  \n\nWelcome to our dream! Nicole and Michael have been together for 17 years and have always dreamed of being able to spread Magic into the world. We love creating together and sharing our love of Magic, Witchcraft and creating beautiful items.  We are here to share the love and intention we put into every magical item we make.  Michael hand draws and hand burns every Pendulum Board and Crystal Grid. His love of Sacred Geometry and healing energy are infused into every board. Nicole creates one of a kind creations filled with her love of Herbal Magic. She has been a practicing Witch her entire life and has always dreamed of teaching a younger generation to follow their hearts and their intuition and find the Magic in themselves. Thank you for supporting our dream and we hope you find the Magic we have found in each other and in doing the things we love. Be kind to each other. We love you. Go make some Magic!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:56.823Z",
    importedBy: "entity-db-cli",
  },
};
